@if (!isLoading) {
  @if (showRequisitions) {
    <rt-bulk-actions-selection-message [hasTopMargin]="false" />
    @for (
      group of requisitionsGroups;
      track trackByIndex(groupIndex, group);
      let groupIndex = $index;
      let groupCount = $count;
      let firstGroup = $first
    ) {
      @if (showGroups) {
        <rt-offers-page-group-heading
          [name]="group.name!"
          [counter]="group.count || 0"
          [state]="collapsedGroups.includes(group.name!) ? 'collapsed' : 'normal'"
          [selectable]="true"
          [selectedCount]="selectedIdsByGroup.get(group.name!)?.length || 0"
          (selectedChange)="onGroupSelectedChange(group, $event)"
          (click)="changeGroupVisibility(group.name!)"
          [attr.margin-top-small]="!firstGroup || null"
          margin-left-small-x
        />
      }
      <div [@collapse]="collapsedGroups.includes(group.name!) ? 'collapsed' : 'normal'">
        <rt-intersection-observer-entry
          [template]="tableTemplate"
          [firstPaintOnly]="true"
          [templateContext]="group"
          [forceVisible]="groupIndex === 0"
        />
      </div>
      <ng-template
        #tableTemplate
        let-group
        let-visible="visible"
        [ngTemplateType]="IntersectionObserverTemplateContext"
      >
        @if (columns) {
          <rt-requisitions-list-table
            [requisitions]="group.requisitions"
            [columns]="columns"
            [autoFit]="autoFit"
            [usersMap]="usersMap"
            [jobsMap]="jobsMap"
            [canEditRequisitions]="canEditRequisitions"
            [selectedIds]="allSelectedIds"
            (openRequisition)="openRequisition($event)"
            (follow)="follow($event)"
            (unfollow)="unfollow($event)"
            (duplicate)="duplicate($event)"
            (archive)="archive($event)"
            (retrieve)="retrieve($event)"
            (delete)="delete($event)"
            (cancelRequest)="cancelRequest($event)"
            (geometryChange)="handleGeometryChange($event)"
            (changeGroupVisibility)="changeGroupVisibility($event)"
            (sortChange)="handleSortChange($event)"
            (rowSelect)="onRowSelect($event)"
          />
        }
      </ng-template>
    }
  } @else {
    <rt-requisitions-list-empty-state-container [params]="params" />
  }
} @else {
  @if (columns) {
    <rt-data-table
      [cols]="columns"
      [rows]="placeloaderRows"
      [defaultCellTemplate]="placeloader"
      [selectable]="true"
      [autoFit]="autoFit"
    />
  }

  <ng-template #placeloader>
    <rt-placeloader [style.height]="'20px'" [style.width]="'60%'" variant="item" />
  </ng-template>
}
